import { ReactNode } from 'react'
import { Home } from './home'
import { Mamoru } from './mamoru'
import { Kakeru } from './kakeru'

type SupportRoute = {
  path: string
  element: ReactNode
}

export const supportRoutes: SupportRoute[] = [
  { path: '/support', element: <Home /> },
  { path: '/support/mamoru', element: <Mamoru /> },
  { path: '/support/kakeru', element: <Kakeru /> },
]
